var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticStyle:{"height":"100%"},attrs:{"id":"app"}})}
var staticRenderFns = []

export { render, staticRenderFns }